import { IRequest } from '../../httpClient/serverApi/types/IRequest';
import WebHttpClient from '../../httpClient/WebHttpClient';

// Modified from https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
export function formatBytes(bytes: number, decimals = 1) {
  if (bytes === 0) return '0';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function isValidExtension(filename: string, validFileTypes: string[]): boolean {
  const fileExtension = getFileExtension(filename);
  return validFileTypes.includes(fileExtension);
}

export function getFileExtension(filename: string): string {
  const indexOfExtension = filename.lastIndexOf('.');
  if (indexOfExtension < 0) {
    return '';
  } else {
    return filename.substring(indexOfExtension);
  }
}

export function getFileNameOnly(filename: string): string {
  return filename.substring(0, filename.lastIndexOf('.'));
}

export function buildContentFilterParams(name: string, projectId: string): any {
  return {
    filter: {
      operator: 'and',
      clauses: [
        { operator: 'eq', field: 'name', value: name },
        { operator: 'eq', field: 'projectId', value: projectId }
      ]
    }
  };
}

export function getContentsCall<TResult>(name: string, projectId: string, RequestClass: new (params: any) => IRequest<any, TResult>): Promise<TResult> {
  return WebHttpClient.sendRequest(new RequestClass(buildContentFilterParams(name, projectId)));
}
